<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else>
      <headline-container :headline="portal.attributes.name" :breadcrumbs="breadcrumbs">
        <div class="btn-group">
          <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-cogs"></i> Portal Functions <span class="caret"></span>
          </button>

          <ul class="dropdown-menu">
            <li v-if="hasPermission('admin')">
              <router-link :to="'/portals/' + portalId + '/channels/create'">
                <i class="fa fa-plus"></i> Create Channel
              </router-link>
            </li>

            <li v-if="hasPermission('admin')">
              <router-link :to="'/portals/' + portalId + '/subscription-types/create'">
                <i class="fa fa-plus"></i> Create Subscription Type
              </router-link>
            </li>

            <li v-if="hasPermission('admin')">
              <router-link :to="'/portals/' + portalId + '/mailing-lists/create'">
                <i class="fa fa-plus"></i> Create Mailing List
              </router-link>
            </li>

            <li v-if="hasPermission('admin')" role="separator" class="divider"></li>

            <li v-if="hasPermission('admin')">
              <a href="#" @click.prevent="downloadMagazineRecipients">
                <i class="fa fa-download"></i> Download Magazine Recipient List
              </a>
            </li>

            <li v-if="hasPermission('admin')">
              <a href="#" @click.prevent="downloadTargetGroup">
                <i class="fa fa-download"></i> Download Target Group
              </a>
            </li>

            <li v-if="hasPermission('admin')" role="separator" class="divider"></li>

            <li v-if="hasPermission('admin')">
              <a @click.prevent="destroy">
                <i class="fa fa-trash"></i> Delete
              </a>
            </li>
          </ul>
        </div>
      </headline-container>

      <sub-menu :portal="portal"></sub-menu>

      <router-view v-model="portal"></router-view>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import store from '@/store'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import Permissions from '@/mixins/Permissions'
import SubMenu from '@/pages/Administration/Portals/Edit/SubMenu'

export default {
  components: {HeadlineContainer, LoadingContainer, SubMenu},

  mixins: [Permissions],

  props: {
    portalId: {
      required: true
    }
  },

  data() {
    return {
      portal: null,

      loading: true,
      shared: store
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    breadcrumbs() {
      return [{url: '/portals', text: 'Portals'}, {text: this.portal.attributes.name}]
    }
  },

  methods: {
    load() {
      http.get('/api/v2/portals/' + this.portalId).then(response => {
        this.portal = response.data.data

        this.loading = false
      })
    },

    destroy() {
      modal.confirm('Are you sure that you want to delete the portal?', () => {
        http.delete('/api/v2/portals/' + this.portal.id)
            .then(() => {
              notify.success('The portal was deleted')

              this.$router.push('/portals')
            })
      })
    },

    downloadMagazineRecipients() {
      axios.post('/api/v1/reports/magazine-recipients', {}, {
        headers: {
          'Authorization': 'Bearer ' + this.shared.token
        },
        params: {
          portal_id: this.portal.id
        },
        responseType: 'blob'
      })
          .then(response => {
            download(response.data, response.headers['content-disposition'].slice(22, -1))
          })
    },


    downloadTargetGroup() {
      axios.post('/api/v1/reports/target-group', {}, {
        headers: {
          'Authorization': 'Bearer ' + this.shared.token
        },
        params: {
          portal_id: this.portal.id
        },
        responseType: 'blob'
      })
          .then(response => {
            download(response.data, response.headers['content-disposition'].slice(22, -1))
          })

    }
  }
}
</script>
